import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';

// Code splitting: Lazy load PricingPage to reduce initial bundle size
const PricingPage = lazy(() =>
  import('@/pages/PricingPage').then((module) => ({ default: module.PricingPage }))
);

export const pricingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/pricing',
  component: PricingPage,
});

// 後方互換性のため
export const Route = pricingRoute;
